import React from 'react';
import './Footer.css';

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>© 2026 Chris House</p>
    </footer>
  );
};
